<template>
  <section class="auth auth__login container">
    <h2 class="title is-2">Accedi</h2>

    <form class="form form__login" @submit.prevent="perform">
      <b-field label="Username">
        <b-input icon="user" autocapitalize="none" type="text" name="username"
                 v-model="loginForm.username"></b-input>
      </b-field>

      <b-field label="Password">
        <b-input icon="key" type="password" name="password" v-model="loginForm.password"
                 password-reveal></b-input>
      </b-field>

      <div class="field">
        <div class="control">
          <button class="button is-large is-primary" type="submit">Accedi</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
  import {api, utils} from '../../helpers/'
  import router from '../../router/'

  export default {
    name: 'Login',
    data () {
      return {
        loginForm: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
      perform () {
        const modal = this.$loading.open()
        api.login(this.loginForm)
          .then(() => {
            this.$toast.open(
              {
                message: 'Accesso effettuato',
                type: 'is-dark',
                position: 'is-bottom'
              })
            modal.close()
            router.replace({name: 'Presence'})
          })
          .catch(errors => utils.errors(errors, modal))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/Login.vue